import store from "@/store";
import { setSigningOut } from "@/configuration/axios";

export default [
  {
    path: "/logout",
    redirect: "/signout",
  },
  {
    path: "/signout",
    beforeEnter: async (to, from, next) => {
      // Prevent axios interceptor from interfering during logout
      setSigningOut(true);

      // Use global sign out action
      const res = await store.dispatch("signOut");

      // Reset flag
      setSigningOut(false);

      // default behavior
      if (!res || !res.redirect_url) {
        next("/signin");
        return;
      }

      // when redirect_url absolute
      if (res.redirect_url.indexOf("http") === 0) {
        window.location = res.redirect_url;
        return;
      }

      // when redirect_url relative
      next(res.redirect_url);
    },
  },
];
